import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { styled } from '@mui/system';

const StyledRouterLink = styled(ReactRouterLink)(() => ({
  color: 'inherit',
  borderBottom: '1px #000000de solid',
  paddingBottom: 1,
  textDecoration: 'none',
  '&:hover': {
    borderBottom: 0
  }
}));

const StyledLink = ({ to, children }) => <StyledRouterLink to={to}>{children}</StyledRouterLink>;

export default StyledLink;
